import { Routes, Route } from "react-router-dom";
import Header from './sections/Header';
import Footer from './sections/Footer';
import { Home, About, BookInspection, Contact, Listings, Listing, Inquiry, NotFound, Login, DashboardLayout, DashboardHome, ManageReviews, ManageListings, ManageTeam, AddListing, AddTeamMember, AddReviews, ReviewUs } from "./pages";
import { ProtectedRoute } from "./Auth";
import ellipseBackground from './assets/images/ellipse.svg';

const AppRoutes = () => {
    return (
      <>
      {/* The overlay element for the "background" image */}
      <div
        style={{
          position: 'absolute', // Use fixed to cover the entire viewport
          top: 0,
          left: 0,
          width: '100vw', // Cover full viewport width
          height: '100vh', // Cover full viewport height
          backgroundImage: `url('${ellipseBackground}')`, // Use your ellipse.svg
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top left',
          zIndex: 10, // A very high z-index to be on top
          pointerEvents: 'none', // Allows clicks/interactions to pass through
        }}
        // Add an onError for the background image in case the path is wrong
        onError={(e) => { e.target.style.backgroundImage = `url('${ellipseBackground}')`; }}
      />
      {/* Header */}
      {!(window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/dashboard')) && <Header />}
      <Routes
        future={{
        v7_startTransition: true,
      }}
      >
        <Route path="/" element={ <Home /> } />
        <Route path="/about" element={ <About /> } />
        <Route path="/properties" element={ <Listings /> } />
        <Route path="/properties/:id" element={ <Listing /> } />
        <Route path="/contact" element={ <Contact /> } />
        <Route path="/inquiry" element={ <Inquiry /> } />
        <Route path="/inspection" element={ <BookInspection /> } />
        <Route path="/review-us" element={ <ReviewUs /> } />
        <Route path="/admin" element={ <Login /> } />
        <Route path="/dashboard" element={ <ProtectedRoute /> }>
          <Route element={ <DashboardLayout /> }>
            <Route path="" element={ <DashboardHome /> } />
            <Route path="manage-reviews" element={ <ManageReviews /> } />
            <Route path="manage-reviews/add" element={ <AddReviews />} />
            <Route path="manage-reviews/edit" element={ <AddReviews />} />
            <Route path="manage-listings" element={ <ManageListings /> } />
            <Route path="manage-listings/add" element={ <AddListing />} />
            <Route path="manage-listings/edit" element={ <AddListing />} />
            <Route path="manage-team" element={ <ManageTeam /> } />
            <Route path="manage-team/add" element={ <AddTeamMember />} />
            <Route path="manage-team/edit" element={ <AddTeamMember />} />
          </Route>
        </Route>
        <Route path="*" element={ <NotFound /> } />
      </Routes>
      {!(window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/dashboard')) && <Footer />}
      </>
    )
}

export default AppRoutes;
